<template>
    <div class = "layout-document ">        
        <div class="title-scan">
            <div>{{labelText}}</div>
            <div class="camera-button-container">
              <img class ='icons-camera'
                :src="require('@/assets/icons/icon-camera.svg')"
                alt="bell icon"
              /> 
            </div>
        </div>
        <div>
          <input type="text" class="general-input mt-1" v-model = form.plateNumber placeholder="Introducir o escanear">
        </div>
        <div class="form-group mt-4">
            <button type="button" @click="submit()" :disabled = "form.plateNumber == ''" class="btn-general">
                {{buttonText}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ocrInput',
  props: [ 'name' ],
  data() {
    return {
        form: {
            plateNumber: ''
        },
        buttonText: '',
        labelText: ''
    }
  },
  mounted() {
    if (this.name == 'truck'){
      this.buttonText = 'ACEPTAR RECOGIDA'
      this.labelText = 'Leer matrícula del vehículo'
    }
    else if (this.name == 'container'){
      this.buttonText = 'RECOGER CONTENEDOR VACÍO'
      this.labelText = 'Leer matrícula del contenedor'
    }
  },
  methods: {
    submit: function () {

    }
  }
}
</script>

<style lang= "scss" scoped>
  .title-scan {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
  }
  .camera-button-container {
    flex: 1;
  }
  .icons-camera { 
    width: 25px;
    float: right;
  }
</style>
